export const WORKFLOW_DEFINITIONS_QUERY_KEY = ["aiagent", "workflow-definitions"];
export const TOKEN_USAGE_QUERY_KEY = ["aiagent", "workflow-runs", "token-usage"];
export const DEFAULT_LAYOUT = {
  entityTableId: "agent-workflows",
  defaultPageSize: 20,
  defaultSort: { attributeId: "title", direction: "asc" },
  defaultDisplayedAttributes: ["title", "description", "disabled", "provider", "model", "last_run_at"],
  defaultColumnOrder: ["title", "description", "disabled", "provider", "model", "last_run_at"]
};
export const ATTRIBUTES = [
  {
    id: "title",
    title: "Title",
    type: "STRING",
    sortable: true,
    searchable: true
  },
  {
    id: "description",
    title: "Description",
    type: "STRING",
    sortable: true,
    searchable: true
  },
  {
    id: "disabled",
    title: "Status",
    type: "BOOLEAN",
    sortable: true,
    filterable: true,
    filter_options: [
      { value: "true", title: "Paused" },
      { value: "false", title: "Running" }
    ]
  },
  {
    id: "provider",
    title: "Provider",
    type: "STRING",
    filterable: true
  },
  {
    id: "model",
    title: "Model",
    type: "STRING",
    sortable: true,
    filterable: true,
    filter_options: [
      { value: "gpt-4.1", title: "GPT-4.1" },
      { value: "gpt-4.1-mini", title: "GPT-4.1 Mini" }
    ]
  },
  {
    id: "last_run_at",
    title: "Last Run",
    type: "DATE",
    sortable: true
  }
];
const keywordRange = (keyword) => ({
  type: "keyword",
  keyword
});
export const tokenUsageRanges = [
  { range: keywordRange("Today"), label: "Today" },
  { range: keywordRange("Monday current week to today"), label: "This Week" },
  { range: keywordRange("1st of current month to today"), label: "This Month" }
];
